import styled from "styled-components";
import {JackpotWidgetAmountDefaultBox} from "./jackpot-widget-amount.default.box";

export const JackpotWidgetAmountrMrGreenBox = styled(JackpotWidgetAmountDefaultBox)`
  color: ${({theme}) => theme.colors.textDark };
  ${({theme, isDaily}) => isDaily ? theme.font.presets.bold : theme.font.presets.body};
  span {
    text-shadow: 0px 2.70px 2.70px rgba(0, 0, 0, 0.29);
  } ;
`;
